var map = {
	"./404.png": 8288,
	"./bear-shota-banner1.webp": 1037,
	"./bear-shota-loop.gif": 7832,
	"./dc-join.png": 5841,
	"./donate.png": 2922,
	"./itchio.png": 5109,
	"./jortsoft-logo.png": 6438,
	"./jortsoft_text_logo.png": 6073,
	"./loading.gif": 6053,
	"./logo.png": 6949,
	"./me.webp": 8872,
	"./path.png": 5461,
	"./patreon_join.png": 7952,
	"./playstore.png": 740,
	"./qatamoidi-banner1.webp": 4141,
	"./qatamoidi-banner2.webp": 8812,
	"./qatamoidi-banner3.webp": 5901,
	"./qatamoidi-loop.gif": 5510,
	"./screamer_cube1.webp": 811,
	"./screamer_cube2.webp": 9131,
	"./screamer_cube3.webp": 7112,
	"./screamercubeBanner.webp": 3140,
	"./sheshlili-joni-banner1.webp": 1063,
	"./sheshlili-joni-banner2.webp": 1848,
	"./sheshlili-joni-banner3.webp": 4952,
	"./sheshlili-joni-loop.gif": 6028,
	"./steam.webp": 2330,
	"./yt-sub.png": 6001,
	"./zephinala-loop.gif": 6286,
	"./zephinala_screen1.jpg": 3759,
	"./zephinala_screen2.jpg": 4411,
	"./zephinala_screen3.jpg": 691,
	"./zephinala_screen4.jpg": 3425,
	"./zephinala_screen5.jpg": 5030,
	"./zephinala_screen6.jpg": 1090
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;